module.exports = __webpack_public_path__ + "static/media/vila_logo.c9b00a2a.png";